// Module
var code = "<div\n  class=\"eagleplayer-advertisement-remain-time eplayer-skin-component eplayer-holdable\">\n  Реклама начнётся через <span>5</span> сек.\n</div>\n";
// Exports
export default code;